import React, { useEffect, useState } from 'react';
import { Alert, Badge, Modal } from 'react-bootstrap';
import { ButtonContainer, StyledButton } from '../../StyledComponets';
import { isNumeric } from '../../helpers/utilities';
const ConfirmCustomer = (props) => {
  const { customerData, confirmCustomer, setConfirmCustomer, resetCustomer } =
    props;

  const processCurrent = (str) => {
    const masklen = str.length > 4 ? 4 : 2;
    const vis = str.slice(-masklen);
    let countNum = '';
    for (var i = str.length - masklen; i > 0; i--) {
      countNum += '*';
    }
    return countNum + vis;
  };

  const maskFewChars = (str) => {
    if (str) {
      var stringArray = str.split(/(\s+)/);
      return stringArray.reduce((pre, curr) => {
        return `${pre} ${isNumeric(curr) ? curr : processCurrent(curr)}`;
      }, '');
    } else return '';
  };

  const checkPendingEnrollemnt = () => {
    return (
      customerData?.isEnrollmentInService ||
      customerData?.isEnrollmentPending ||
      customerData?.isEnrollmentPendingExpansion
    );
  };

  return customerData?.serviceAddress ? (
    <Modal centered size="lg" show={confirmCustomer}>
      <Modal.Body>
        <h5>Please verify below account information and confirm.</h5>
        <h6>
          Your service registered address
          <Badge bg="light" text="danger">
            {`${maskFewChars(customerData?.serviceAddress.address1)}
                 ${maskFewChars(customerData?.serviceAddress.address2)}
                 ${customerData?.serviceAddress.city} ${
              customerData?.serviceAddress.state
            }
                 ${customerData?.serviceAddress.zipCode?.substring(0, 5)}
                `}
          </Badge>
        </h6>
        {checkPendingEnrollemnt() && (
          <Badge pill bg="warning" text="dark">
            You have pending application
          </Badge>
        )}
        <ButtonContainer>
          <StyledButton
            btnType="secondary"
            variant="dark"
            size="md"
            onClick={() => {
              resetCustomer();
              setConfirmCustomer(false);
            }}
          >
            No,Reset
          </StyledButton>
          <StyledButton
            type="submit"
            btnType="primary"
            variant="dark"
            size="md"
            onClick={async () => {
              await setConfirmCustomer(false);
              props.setHavePendingEnroll(checkPendingEnrollemnt());
            }}
          >
            Yes,It's me
          </StyledButton>
        </ButtonContainer>
      </Modal.Body>
    </Modal>
  ) : (
    <></>
  );
};

export default ConfirmCustomer;
